module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GRAPHITE_STYLE.dcbf25a0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GRAPHITE_STYLE.png
// module id = 1160
// module chunks = 16